import React from 'react';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import Button from 'tailwind-components/Button/Button';
import { Copy } from 'lucide-react';
import { useDispatch } from 'react-redux';
import propTypes from 'prop-types';
import { showAlert } from 'state/actions/site';

export default function CopyButton({ text, label }) {
  const dispatch = useDispatch();
  const copyText = () => {
    navigator.clipboard.writeText(text);
    dispatch(
      showAlert({ message: `${label} copied to clipboard!`, code: 'success' })
    );
  };

  return (
    <SimpleContainer className='gap-0'>
      <p className='text-base font-semibold m-0'>{label}</p>
      <Button
        variant='transparent'
        size='small'
        fill
        icon={
          <Copy
            size={20}
            className='text-primary-darkened hover:text-primary-darkened/80'
          />
        }
        text={text}
        rounded='small'
        className='flex-row-reverse justify-between border-grey-lighter hover:border-grey-light'
        onClick={copyText}
      />
    </SimpleContainer>
  );
}

CopyButton.propTypes = {
  text: propTypes.string.isRequired,
  label: propTypes.string.isRequired
};
